module.exports = __webpack_public_path__ + "static/media/texture-brown-d.0a5720d0.png";